// @mui material components
import React from "react";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/PoliceInfoCard";

// Overview page components
import Header from "layouts/profile/components/Header";
import API_CONFIG from "../../../config";
import axios from "axios";

function Overview() {
  // Fetch profile data here if needed
  const [profileData, setProfileData] = React.useState(null);
  const fetchProfileData = async () => {
    try {
      const token = sessionStorage.getItem("authToken") || sessionStorage.getItem("token");
      const response = await axios.get(`${API_CONFIG.BASE_URL}admin/police/profile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setProfileData(response.data.data);
    } catch (error) {
      console.error("Error fetching profile data:", error);
      return null;
    }
  };

  React.useEffect(() => {
    fetchProfileData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header>
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={10} xl={8} sx={{ display: "flex" }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              <ProfileInfoCard
                title="profile information"
                description="Hi, I’m FlyHomes, Decisions: If you can’t decide, the answer is no. If two equally difficult paths, choose the one more painful in the short term (pain avoidance is creating an illusion of equality)."
                info={{
                  stationName: profileData ? profileData.station_name : "Loading...",
                  mobile: profileData ? profileData.phone : "Loading...",
                  email: profileData ? profileData.user_id : "Loading...",
                  district: profileData ? profileData.district : "Loading...",
                  state: profileData ? profileData.state : "Loading...",
                  city: profileData ? profileData.city : "Loading...",
                }}
                social={[
                  {
                    link: "https://www.facebook.com/CreativeTim/",
                    icon: <FacebookIcon />,
                    color: "facebook",
                  },
                  {
                    link: "https://twitter.com/creativetim",
                    icon: <TwitterIcon />,
                    color: "twitter",
                  },
                  {
                    link: "https://www.instagram.com/creativetimofficial/",
                    icon: <InstagramIcon />,
                    color: "instagram",
                  },
                ]}
                action={{ route: "", tooltip: "Edit Profile" }}
                shadow={false}
              />
              <Divider orientation="vertical" sx={{ mx: 0 }} />
            </Grid>
          </Grid>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;
